import { EyeIcon } from '@heroicons/react/24/solid';
import React from 'react';
import { Link } from 'react-router-dom';

const ListCustomers = () => {
    // Static customer data (real-world-like)
    const customers = [
        {
            id: 1,
            name: 'John Doe',
            email: 'john.doe@example.com',
            phone: '+1 123-456-7890',
            address: '123 Elm Street, Springfield, IL',
            purchasedProducts: [
                { name: 'Laptop', quantity: 1, price: 1200 },
                { name: 'Wireless Mouse', quantity: 1, price: 25 },
            ],
            totalSpent: 1225,
        },
        {
            id: 2,
            name: 'Jane Smith',
            email: 'jane.smith@example.com',
            phone: '+1 234-567-8901',
            address: '456 Oak Avenue, Los Angeles, CA',
            purchasedProducts: [
                { name: 'Smartphone', quantity: 1, price: 800 },
                { name: 'Bluetooth Headphones', quantity: 2, price: 50 },
            ],
            totalSpent: 900,
        },
        {
            id: 3,
            name: 'Michael Johnson',
            email: 'michael.johnson@example.com',
            phone: '+1 345-678-9012',
            address: '789 Pine Road, Miami, FL',
            purchasedProducts: [
                { name: 'Smartwatch', quantity: 1, price: 200 },
                { name: 'Wireless Charger', quantity: 1, price: 40 },
            ],
            totalSpent: 240,
        },
        {
            id: 4,
            name: 'Emily Davis',
            email: 'emily.davis@example.com',
            phone: '+1 456-789-0123',
            address: '101 Maple Street, Dallas, TX',
            purchasedProducts: [
                { name: 'Tablet', quantity: 1, price: 350 },
                { name: 'Keyboard', quantity: 1, price: 80 },
            ],
            totalSpent: 430,
        },
        {
            id: 5,
            name: 'David Wilson',
            email: 'david.wilson@example.com',
            phone: '+1 567-890-1234',
            address: '202 Birch Boulevard, New York, NY',
            purchasedProducts: [
                { name: 'Gaming Console', quantity: 1, price: 500 },
                { name: 'Game Controller', quantity: 2, price: 60 },
            ],
            totalSpent: 620,
        },
    ];

    return (
        <div className="overflow-x-auto relative  sm:rounded-lg">
            <h2 className="text-2xl font-bold mb-4">Customer List</h2>

            <div className='py-10 h-[700px] bg-white rounded-xl px-2' >

                <table className="w-full text-sm text-left text-black">
                    <thead className="text-xs text-gray-700 uppercase bg-gray-100">
                        <tr>
                            <th className="py-3 px-6">Customer Name</th>
                            <th className="py-3 px-6">Email</th>
                            <th className="py-3 px-6">Phone</th>
                            <th className="py-3 px-6">Address</th>
                            <th className="py-3 px-6">Purchased Products</th>
                            <th className="py-3 px-6">Total Spent</th>
                            <th className="py-3 px-6">Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {customers.map((customer) => (
                            <tr key={customer.id} className="border-b bg-white">
                                <td className="py-3 px-6">{customer.name}</td>
                                <td className="py-3 px-6">{customer.email}</td>
                                <td className="py-3 px-6">{customer.phone}</td>
                                <td className="py-3 px-6">{customer.address}</td>
                                <td className="py-3 px-6">
                                    <ul>
                                        {customer.purchasedProducts.map((product, index) => (
                                            <li key={index}>
                                                {product.name} (x{product.quantity}) - ${product.price * product.quantity}
                                            </li>
                                        ))}
                                    </ul>
                                </td>
                                <td className="py-3 px-6">${customer.totalSpent}</td>
                                <td className="px-6 py-3 flex justify-center">
                                    <Link to={`/ng-admin/customers/${customer.id}`}>
                                        <EyeIcon
                                            className=" h-5 w-5 text-[#5FBDB3] cursor-pointer hover:text-blue-700"

                                        >

                                        </EyeIcon>
                                    </Link>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div >
    );
};

export default ListCustomers